import { fromJS } from "immutable";

export default fromJS({
	awaitingRequests: {},
	initialized: false,
	activeSection: "asap-daily",
});
